import React, { Fragment } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import DatePicker from 'material-ui/DatePicker';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import { KeyboardArrowRight, AddCircle, DoNotDisturbOn } from '@material-ui/icons'
import { formats } from './fileUploadAllowedFormats';
import { getTdsSection, validatePancard } from '../utils/VendorApiUtils'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
const errorText = 'This field is required'
class VendorFinancialDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        payment_mode: 'online payment',
        beneficiary_name: '',
        bank_acc_number: '',
        ifsc_code: '',
        bank_name: '',
        trade_licence_file: null,
        trade_licence_file_name: '',
        cancel_cheque_upload_file: null,
        cancel_cheque_upload_file_name: '',
        msme_certificate_file: null,
        msme_certificate_file_name: '',
        msme_certificate: '',
        msme_vendor: '',
        tds_liability: 'yes',
        tds_liability_remarks: '',
        confirm_bank_acc_number: '',
        pancard_number: '',
        pancard_file: undefined,
        pancard_file_name: '',
        pancard_status: '1',
        aadhar_number: '',
        aadhar_file: undefined,
        aadhar_file_name: '',
        company_category: '',
        contractual_terms: '',
        vendor_agreement: '',
        agreement_expiry_date: '',
        vendor_agreement_file: null,
        vendor_agreement_file_name: '',
        vendor_ldc_agreement: '',
        ldc_agreement_start_date: '',
        ldc_agreement_end_date: '',
        ldc_tds_rate_data: [{
          tds_section_name_id: '',
          ldc_rate: 0,
          ldc_amount_limit: 0,
          tds_section_name: ''
        }],
        vendor_ldc_agreement_file: null,
        vendor_ldc_agreement_file_name: '',
        central_finance_remarks: '',
        city_finance_remarks: '',
        defaultor_amount: 0,
      },
      tds_liabilities: ['Yes', 'No'],
      payment_modes: ['Cash', 'Card Swipe', 'Cheque', 'DD', 'Online Payment'],
      acceptedFormats: ['image/png','image/jpeg', 'application/pdf'],
      allowedFileSize: 5242880,
      pancard_numberErr: '',
      pancard_numberErrText: '',
      aadhar_numberErr: '',
      aadhar_numberErrText: '',
      confirm_bank_acc_numberErrText: '',
      confirm_bank_acc_numberErr: false,
      msme_vendorErrText: '',
      msme_vendorErr: false,
      msmeCertificateErrText: '',
      msmeCertificateErr: false,
      pancardValidationMessage: '',
      pancardValidationMessageError: false,
      vendorAgreementErrorText: '',
      vendorAgreementError: false,
      vendorLdcAgreementErrText: '',
      vendorLdcAgreementErr: false,
      vendor_ldc_agreement_file_nameErrText: '',
      vendor_ldc_agreement_file_nameErr: false,
      payment_modeErrText: '',
      beneficiary_nameErrText: '',
      bank_acc_numberErrText: '',
      ldc_tds_rate_ErrData: [{
        tds_section_name_idErrText: '',
        tds_section_name_idErr: false,
        ldc_amount_limitErrText: '',
        ldc_amount_limitErr: false,
        ldc_rateErrText: '',
        ldc_rateErr: false,
      }],
      ifsc_codeErrText: '',
      bank_nameErrText: '',
      payment_modeErr: false,
      beneficiary_nameErr: false,
      bank_acc_numberErr: false,
      ifsc_codeErr: false,
      bank_nameErr: false,
      pancardNumberErrorText: '',
      pancardNumberError: false,
      pancardFileErrorText: '',
      pancardFileError: false,
      aadharNumberError: false,
      aadharNumberErrorText: '',
      aadharFileErrorText: '',
      aadharFileError: false,
      tdsLiabilityErrorText: '',
      tdsLiabilityError: false,
      bankACIsAlphaNumeric: false,
      showBankAplhaNumDialog: false,
      vendorExistsDialogBox: false,
      vendorExistsDialogBoxText: '',
      ldcTdsSectionTypes: [],
    }
  }

  fetchTDSsections = async () => {
    try {
      const resp = await getTdsSection()
      if (resp.flag) {
        this.setState({ ldcTdsSectionTypes: resp.data })
      } else {
        this.setState({ snackText: resp.message, snackOpen: true })
      }
    } catch (error) {
      console.log(error)
    }
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({ 
        data: {
          ...this.state.data, 
          ...this.props.data, 
          tds_liability: "yes",
          agreement_expiry_date: this.props.data.agreement_expiry_date ? new Date(this.props.data.agreement_expiry_date) : this.props.data.agreement_expiry_date,
          ldc_agreement_start_date: this.props.data.ldc_agreement_start_date ? new Date(this.props.data.ldc_agreement_start_date) : this.props.data.ldc_agreement_start_date,
          ldc_agreement_end_date: this.props.data.ldc_agreement_end_date ? new Date(this.props.data.ldc_agreement_end_date) : this.props.data.ldc_agreement_end_date,
          ldc_tds_rate_data: this.props.data.ldc_tds_rate_data ? this.props.data.ldc_tds_rate_data : [{
            tds_section_name_id: '',
            ldc_rate: 0,
            ldc_amount_limit: 0,
            tds_section_name: ''
          }]
        },
        ldc_tds_rate_ErrData: this.props.data.ldc_tds_rate_data ? this.props.data.ldc_tds_rate_data.map(() => {
          return {
            tds_section_name_idErrText: '',
            tds_section_name_idErr: false,
            ldc_rateErrText: '',
            ldc_rateErr: false,
          }
        }) : [{
          tds_section_name_idErrText: '',
          tds_section_name_idErr: false,
          ldc_rateErrText: '',
          ldc_rateErr: false,
        }]
      })
    }
    this.fetchTDSsections();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      this.setState({ 
        data: {
          ...this.state.data, 
          ...nextProps.data,
          agreement_expiry_date: nextProps.data.agreement_expiry_date && typeof nextProps.data.agreement_expiry_date == 'string' ? new Date(nextProps.data.agreement_expiry_date) : nextProps.data.agreement_expiry_date,
          ldc_agreement_start_date: nextProps.data.ldc_agreement_start_date && typeof nextProps.data.ldc_agreement_start_date == 'string' ? new Date(nextProps.data.ldc_agreement_start_date) : nextProps.data.ldc_agreement_start_date,
          ldc_agreement_end_date: nextProps.data.ldc_agreement_end_date && typeof nextProps.data.ldc_agreement_end_date == 'string' ? new Date(nextProps.data.ldc_agreement_end_date) : nextProps.data.ldc_agreement_end_date,
          ldc_tds_rate_data: nextProps.data.ldc_tds_rate_data ? nextProps.data.ldc_tds_rate_data : [{
            tds_section_name_id: '',
            ldc_rate: 0,
            tds_section_name: ''
          }]
        },
        ldc_tds_rate_ErrData: nextProps.data.ldc_tds_rate_data ? nextProps.data.ldc_tds_rate_data.map(() => {
          return {
            tds_section_name_idErrText: '',
            tds_section_name_idErr: false,
            ldc_rateErrText: '',
            ldc_rateErr: false,
          }
        }) : [{
          tds_section_name_idErrText: '',
          tds_section_name_idErr: false,
          ldc_rateErrText: '',
          ldc_rateErr: false,
        }]
      })
    }
  }
  async handleNext() {
    if (this.state.data.payment_mode === '') {
      this.setState({ payment_modeErrText: errorText, payment_modeErr: true })
    }
    if (this.state.data.payment_mode === 'online payment') {
      if (this.state.data.beneficiary_name === '') {
        this.setState({ beneficiary_nameErrText: errorText, beneficiary_nameErr: true })
      }
      if (this.state.data.bank_acc_number === '') {
        this.setState({ bank_acc_numberErrText: errorText, bank_acc_numberErr: true })
      }
      if (this.state.data.ifsc_code === '') {
        this.setState({ ifsc_codeErrText: errorText, ifsc_codeErr: true })
      }
      if (this.state.data.bank_name === '') {
        this.setState({ bank_nameErrText: errorText, bank_nameErr: true })
      }
      if (typeof this.state.data.cancel_cheque_upload_file_name === 'undefined' || this.state.data.cancel_cheque_upload_file_name === '') {
        this.setState({ cancelChequeErrorText: errorText, cancelChequeError: true })
        return false;
      }
    }
    if (this.state.data.bank_acc_number !== '') {
      let myregex = /^[A-Za-z0-9]{6,18}$/
      if (!myregex.test(this.state.data.bank_acc_number)) {
        this.setState({ snackText: 'Invalid Bank Account number', snackOpen: true })
        return
      }
    }
    if (this.state.data.bank_acc_number !== this.state.data.confirm_bank_acc_number) {
      this.setState({ snackText: 'Bank account number did not match ', snackOpen: true })
      return
    }
    if (this.state.data.ifsc_code !== '') {
      let myRegxp = /^([a-zA-Z0-9_-]){11}$/;
      if (!myRegxp.test(this.state.data.ifsc_code)) {
        this.setState({ snackText: "IFSC length should be 11 characters", snackOpen: true })
        return
      }
    }
    if (this.state.data.pancard_number !== '') {
      let myRegxp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!myRegxp.test(this.state.data.pancard_number)) {
        this.setState({ snackText: "Invalid Pan number", snackOpen: true, pancard_numberErrText: 'Invalid PAN number', pancard_numberErr: true })
        return
      }
    }
    if (this.state.data.aadhar_number !== "null" && this.state.data.aadhar_number !== "undefined" && this.state.data.aadhar_number) {
      let myRegxp = /^([0-9_-]){12}$/;
      if (!myRegxp.test(this.state.data.aadhar_number)) {
        this.setState({ snackText: "Aadhaar number length should be 12 characters", snackOpen: true })
        return
      }
    }
    if (this.state.data.tds_liability === '') {
      this.setState({ tdsLiabilityErrorText: errorText, tdsLiabilityError: true })
      return;
    }

    if (this.state.data.tds_liability === 'yes' && this.state.data.pancard_number === ''){
      this.setState({ pancardNumberErrorText: errorText, pancardNumberError: true })
      return;
    }

    if (this.state.data.tds_liability === 'yes' && this.state.data.pancard_file_name === ''){
      this.setState({ pancardFileErrorText: errorText, pancardFileError: true })
      return;
    }

    if(this.state.data.vendorName !== this.state.data.beneficiary_name && (this.state.data.trade_licence_file === null || this.state.data.trade_licence_file_name === "")){
      this.setState({ tradeFileErrText: errorText, tradeFileError: true })
      return;
    }

    if(this.state.data.vendor_agreement === '') {
      this.setState({ vendor_agreementErrorText: errorText, vendor_agreementError: true })
      return;
    }

    if (this.state.data.vendor_agreement === '1' && this.state.data.vendor_agreement_file_name === ''){
      this.setState({ vendorAgreementErrorText: errorText, vendorAgreementError: true })
      return;
    }

    if(this.state.data.vendor_agreement === '1' && (this.state.data.agreement_expiry_date === '' || this.state.data.agreement_expiry_date === null)){
      this.setState({ agreementExpiryDateErrorText: errorText, agreementExpiryDateError: true })
      return;
    }

    if(!this.state.data.vendor_ldc_agreement) {
      this.setState({ 
        vendor_ldc_agreementErrText: errorText, vendor_ldc_agreementErr: true 
      })
      return;
    }

    if(this.state.data.vendor_ldc_agreement === '1' && (!this.state.data.ldc_agreement_start_date)){
      this.setState({ ldc_agreement_start_dateErrText: errorText, ldc_agreement_start_dateErr: true })
      return;
    }

    if(this.state.data.vendor_ldc_agreement === '1' && (!this.state.data.ldc_agreement_end_date)){
      this.setState({ ldc_agreement_end_dateErrText: errorText, ldc_agreement_end_dateErr: true })
      return;
    }

    if(this.state.data.vendor_ldc_agreement === '1') {
      let ldcTdsRateData = this.state.data.ldc_tds_rate_data;
      let ldcTdsRateErrData = this.state.ldc_tds_rate_ErrData;
      let ldcTdsRateErr = false;
      ldcTdsRateData.forEach((data, index) => {
        if(data.tds_section_name_id === ''){
          ldcTdsRateErrData[index].tds_section_name_idErrText = errorText;
          ldcTdsRateErrData[index].tds_section_name_idErr = true;
          ldcTdsRateErr = true;
        }
        if(data.ldc_rate === ''){
          ldcTdsRateErrData[index].ldc_rateErrText = errorText;
          ldcTdsRateErrData[index].ldc_rateErr = true;
          ldcTdsRateErr = true;
        }
        if(data.ldc_amount_limit === ''){
          ldcTdsRateErrData[index].ldc_amount_limitErrText = errorText;
          ldcTdsRateErrData[index].ldc_amount_limitErr = true;
          ldcTdsRateErr = true;
        }
      })
      if(ldcTdsRateErr){
        this.setState({ ldcTdsRate_ErrData: ldcTdsRateErrData });
        return;
      }
    }

    if (this.state.data.vendor_ldc_agreement === '1' && (!this.state.data.vendor_ldc_agreement_file_name)){
      this.setState({ vendor_ldc_agreement_file_nameErrText: errorText, vendor_ldc_agreement_file_nameErr: true })
      return;
    }

    if(this.state.data.msme_vendor === '') {
      this.setState({ msme_vendorErrText: errorText, msme_vendorErr: true })
      return;
    }

    if (this.state.data.msme_vendor === '1' && this.state.data.msme_certificate_file_name === ''){
      this.setState({ msmeCertificateErrText: errorText, msmeCertificateErr: true })
      return;
    }

    // Pancard duplicate check only applies to new onboards, not edits
    if (this.state.data.state !== 'edit') {
      const pancardValidationResponse = await validatePancard(this.state.data.pancard_number);
      if (pancardValidationResponse.status === 'duplicate') {
        this.setState({ vendorExistsDialogBoxText: pancardValidationResponse.message, vendorExistsDialogBox: true })
        return;
      }
    }

    if (this.state.data.payment_mode !== '' && (this.state.data.payment_mode !== 'online payment' || (this.state.data.beneficiary_name !== '' && this.state.data.bank_acc_number !== '' && this.state.data.ifsc_code !== '' && this.state.data.bank_name !== '' && this.state.data.cancel_cheque_upload_file_name !== ''))) {
      this.moveToNext();
    }
  }
  moveToNext = () => {
    //! Removing the bank details validation for now
    // this.state.data.state !== 'edit' ? validateBankDetails({bank_acc_number: this.state.data.bank_acc_number})
    //     .then(response => {
    //       if (response) {
    //         if (response.status === 'success') {
    //           this.props.handleNext(this.state.data)
    //         }
    //         else if(response.status === 'duplicate'){
    //           this.setState({ vendorExistsDialogBoxText: response.message, vendorExistsDialogBox: true })
    //         }
    //         else {
    //           this.setState({ snackText: response.message, snackOpen: true })
    //         }
    //       }
    //     }) : this.props.handleNext(this.state.data)
    this.props.handleNext(this.state.data)
  }
  handleChange = (props) => (event, index, value) => {
    if (props === 'tds_liability') {
      this.setState({
        data: {
          ...this.state.data, tds_liability: event.target.value, tds_liability_remarks: '',
          pancard_file_name: '', pancard_file: null, pancard_number: '', pancard_status: '1', aadhar_file_name: '', aadhar_file: null, aadhar_number: ''
        }
      })
    }
    else if (props === 'payment_mode') {
      this.setState({
        data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '',
        beneficiary_name: '', bank_acc_number: '', ifsc_code: '', bank_name: '', cancel_cheque_upload_file: null,
        cancel_cheque_upload_file_name: '', [props + 'Err']: false
      })
    }
    else if (props === 'bank_acc_number') {
      let ac_number = event.target.value;
      let letters = /^[A-Za-z]$/
      let myregexAlphaNum = /^[A-Za-z0-9]{0,18}$/
      //for resetting behaviour when blank
      if(ac_number === '')
        this.setState({bankACIsAlphaNumeric: false})
        
      //for catching an alphabetic entry to display the pop-up
      if (letters.test(event.target.value.slice(-1)) && this.state.bankACIsAlphaNumeric === false){
          this.setState({bankACIsAlphaNumeric: true, showBankAplhaNumDialog: true})
        }
      if (!myregexAlphaNum.test(ac_number)) {
        this.setState({ snackText: 'Invalid Bank number', snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: ac_number }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'confirm_bank_acc_number') {
      let myregexAlphaNum = /^[A-Za-z0-9]{0,18}$/
      if (!myregexAlphaNum.test(event.target.value)) {
        this.setState({ snackText: 'Invalid Bank number in Confirm Field', snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'ifsc_code') {
      let myRegxp = /^([a-zA-Z0-9_-]){0,11}$/;
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "Invalid IFSC Code", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value.toUpperCase() }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'pancard_number') {
      let myRegxp = /^([a-zA-Z0-9_-]){0,10}$/;
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "Invalid  PAN Number", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value.toUpperCase() }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'pancard_status') {
      this.setState({
        data: {
          ...this.state.data,
          pancard_status: event.target.checked ? '0' : '1'
        }
      })  
    }
    else if (props === 'aadhar_number') {
      let myRegxp = /^([0-9_-]){0,12}$/;
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "Invalid  Aadhaar Number", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value.toUpperCase() }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'beneficiary_name') {
      let ben_name = event.target.value;
      if ( ben_name && ben_name.length > 100 ) {
        this.setState({ snackText: "Beneficiary name can have maximum 100 characters", snackOpen: true })
        return
      }
      if(/^\s/.test(ben_name)){
        this.setState({ snackText: "Beneficiary name can't start with whitespace", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'agreement_expiry_date' || props === 'ldc_agreement_start_date' || props === 'ldc_agreement_end_date') {
      this.setState({ 
        data: { 
          ...this.state.data, 
          [props]: index 
        }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
    else if (props === 'vendor_agreement' || props === 'vendor_ldc_agreement') {
      let isAgreement = event.target.value;
      if (isAgreement === '0') {
        this.setState({ data: { ...this.state.data, [props]: event.target.value, vendor_agreement_file: null, vendor_agreement_file_name: '', agreement_expiry_date: '' } })
      } else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
      }

      
    }
    else if (props === 'tds_section_name_id' || props === 'ldc_rate' || props === 'ldc_amount_limit') {
      let ldcTdsRateData = this.state.data.ldc_tds_rate_data;
      let ldcTdsRateErrData = this.state.ldc_tds_rate_ErrData;
      if(props === 'tds_section_name_id') {
        const findLDCSection = this.state.ldcTdsSectionTypes.find((section) => section.id === event.target.value);
        ldcTdsRateData[index]['tds_section_name'] = findLDCSection.section_name;
      }
      ldcTdsRateData[index][props] = event.target.value;
      ldcTdsRateErrData[index][props + 'ErrText'] = '';
      ldcTdsRateErrData[index][props + 'Err'] = false;
      this.setState({ 
        data: { 
          ...this.state.data, 
          ldc_tds_rate_data: ldcTdsRateData 
        },
        ldc_tds_rate_ErrData: ldcTdsRateErrData
      })
    }
    else {
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
  }
  chequeFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, cancel_cheque_upload_file: event.target.files[0], cancel_cheque_upload_file_name: event.target.files[0].name }, cancelChequeErrorText: '', cancelChequeError: false })
      }
      else {
        this.setState({ cancelChequeErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, cancelChequeError: true });
        return false;
      }
    }
    else {
      this.setState({ cancelChequeErrorText: 'Only png,jpeg,pdf images are allowed for this field', cancelChequeError: true });
      return false;
    }
  }

  tradeFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, trade_licence_file: event.target.files[0], trade_licence_file_name: event.target.files[0].name }, tradeFileErrText: '', tradeFileError: false })
      }
      else {
        this.setState({ tradeFileErrText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, tradeFileError: true });
        return false;
      }
    }
    else {
      this.setState({ tradeFileErrText: 'Only png,jpeg,pdf images are allowed for this field', tradeFileError: true });
      return false;
    }
  }

  pancardFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, pancard_file: event.target.files[0], pancard_file_name: event.target.files[0].name },pancardFileErrorText: '', pancardFileError: false })
      }
      else {
        this.setState({ pancardFileErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, pancardFileError: true });
        return false;
      }
    }
    else {
      this.setState({ pancardFileErrorText: 'Only png,jpeg,pdf images are allowed for this field', pancardFileError: true })
      return false;
    }
  }

  aadharFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, aadhar_file: event.target.files[0], aadhar_file_name: event.target.files[0].name }, aadharFileErrorText: '', aadharFileError: false })
      }
      else {
        this.setState({ aadharFileErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, aadharFileError: true });
        return false;
      }
    }
    else {
      this.setState({ aadharFileErrorText: 'Only png,jpeg,pdf images are allowed for this field', aadharFileError: true })
      return false;
    }
  }

  msmeCertificateFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, msme_certificate_file: event.target.files[0], msme_certificate_file_name: event.target.files[0].name },msmeCertificateErrorText: '', msmeCertificateError: false })
      }
      else {
        this.setState({ msmeCertificateErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, msmeCertificateError: true });
        return false;
      }
    }
    else {
      this.setState({ msmeCertificateErrorText: 'Only png,jpeg,pdf images are allowed for this field', msmeCertificateError: true })
      return false;
    }
  }

  vendorAgreementFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, vendor_agreement_file: event.target.files[0], vendor_agreement_file_name: event.target.files[0].name },vendorAgreementErrorText: '', vendorAgreementError: false })
      }
      else {
        this.setState({ vendorAgreementErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, vendorAgreementError: true });
        return false;
      }
    }
    else {
      this.setState({ vendorAgreementErrorText: 'Only png,jpeg,pdf images are allowed for this field', vendorAgreementError: true })
      return false;
    }
  }

  vendorLdcAgreementFileHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ 
          data: { 
            ...this.state.data, 
            vendor_ldc_agreement_file: event.target.files[0], 
            vendor_ldc_agreement_file_name: event.target.files[0].name 
          }, 
          vendorLdcAgreementErrorText: '', 
          vendorLdcAgreementError: false 
        })
      }
      else {
        this.setState({ 
          vendorLdcAgreementErrorText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, 
          vendorLdcAgreementError: true 
        });
        return false;
      }
    }
    else {
      this.setState({ 
        vendorLdcAgreementErrorText: 'Only png,jpeg,pdf images are allowed for this field', vendorLdcAgreementError: true 
      })
      return false;
    }
  }

  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleClick = (props) => (event, index, value) => {
    if (props !== 'bank_acc_number' && this.state.data.bank_acc_number !== '') {
      if (this.state.data.bank_acc_number.length < 6) {
        this.setState({ bank_acc_numberErrText: 'Invalid number (Max length is 6-18) ', bank_acc_numberErr: true })
      }
    }
    if (props !== 'confirm_bank_acc_number' && this.state.data.confirm_bank_acc_number !== '' && this.state.data.confirm_bank_acc_number) {
      if (this.state.data.confirm_bank_acc_number.length < 6) {
        this.setState({ confirm_bank_acc_numberErrText: 'Invalid number (Max length is 6-18) ', confirm_bank_acc_numberErr: true })
      }
    }
    if (props !== 'ifsc_code' && this.state.data.ifsc_code !== '') {
      if (this.state.data.ifsc_code.length !== 11) {
        this.setState({ ifsc_codeErrText: 'Invalid IFSC Code (length should be 11 characters) ', ifsc_codeErr: true })
      }
    }
    if (props !== 'pancard_number' && this.state.data.pancard_number !== '') {
      if (this.state.data.pancard_number.length !== 10) {
        this.setState({ pancard_numberErrText: 'Invalid PAN number (length should be 10 characters) ', pancard_numberErr: true })
      }
    }
    if (props !== 'aadhar_number' && this.state.data.aadhar_number !== "null" && this.state.data.aadhar_number !== "undefined" && this.state.data.aadhar_number) {
      if (this.state.data.aadhar_number.length !== 12) {
        this.setState({ aadhar_numberErrText: 'Invalid Aadhaar number (length should be 12 characters) ', aadhar_numberErr: true })
      }
    }
  }
  handleBankAplhaNumDialogClose() {
    this.setState({showBankAplhaNumDialog: false})
  }

  handleBankAplhaNumDialogYes() {
    this.setState({showBankAplhaNumDialog: false})
  }

  handleBankAplhaNumDialogNo() {
    this.setState({showBankAplhaNumDialog: false, bankACIsAlphaNumeric: false, data:{ ...this.state.data, bank_acc_number: ''}})
  }

  handleClear() {
    this.setState({
      bankACIsAlphaNumeric: false,
      data: {
        vendorName: this.state.data.vendorName,
        payment_mode: '',
        beneficiary_name: '',
        bank_acc_number: '',
        ifsc_code: '',
        bank_name: '',
        trade_licence_file: null,
        trade_licence_file_name: '',
        cancel_cheque_upload_file: null,
        cancel_cheque_upload_file_name: '',
        tds_liability: '',
        tds_liability_remarks: '',
        confirm_bank_acc_number: '',
        pancard_number: '',
        pancard_file: undefined,
        pancard_file_name: '',
        aadhar_number: '',
        aadhar_file: undefined,
        aadhar_file_name: '',
        msme_vendor: '',
        msme_certificate_file: undefined,
        msme_certificate_file_name: '',
        company_category: '',
        contractual_terms: '',
        central_finance_remarks: '',
        city_finance_remarks: '',
      }
    })

  }
  handleCloseVendorExistsDialogBox(){
    this.setState({vendorExistsDialogBox: false, vendorExistsDialogBoxText:''})
  }

  addLdcTdsRate = () => {
    this.setState({
      data: {
        ...this.state.data,
        ldc_tds_rate_data: [
          ...this.state.data.ldc_tds_rate_data,
          {
            ldc_rate: 0,
            ldc_amount_limit: 0,
            tds_section_name_id: '',
          }
        ]
      },
      ldc_tds_rate_ErrData: [
        ...this.state.ldc_tds_rate_ErrData,
        {
          tds_section_name_idErrText: '',
          tds_section_name_idErr: false,
          ldc_amount_limitErrText: '',
          ldc_amount_limitErr: false,
          ldc_rateErrText: '',
          ldc_rateErr: false,
        }
      ]
    })
  }

  removeLdcTdsRate = (index) => {
    this.setState({
      data: {
        ...this.state.data,
        ldc_tds_rate_data: this.state.data.ldc_tds_rate_data.filter((data, i) => i !== index)
      },
      ldc_tds_rate_ErrData: this.state.ldc_tds_rate_ErrData.filter((data, i) => i !== index)
    })
  }

  render() {
    return (
      <div><FormControl style={{ marginTop: '10px' }}>
        <InputLabel htmlFor="payment-mode">*Payment Mode</InputLabel>
        <Select
          value={this.state.data.payment_mode}
          onChange={this.handleChange('payment_mode')}
          onClick={this.handleClick('payment_mode')}
          inputProps={{
            name: 'Payment Mode',
            id: 'payment-mode',
          }}
          style={{ width: '250px', marginRight: '270px', textAlign: 'left' }}
          helperText={this.state.payment_modeErrText}
          error={this.state.payment_modeErr}

        >
          {
            this.state.payment_modes.map(payment_mode => {
              return <MenuItem value={payment_mode.toLowerCase()}>{payment_mode}</MenuItem>
            })
          }
        </Select>
        <FormHelperText style={{ color: 'red' }}>{this.state.payment_modeErrText}</FormHelperText>
      </FormControl><br />
        {this.state.data.payment_mode === 'online payment' &&
          <div>
            <div style={{ display: "flex" }}>
              <TextField
                label="*Trade licence copy"
                value={this.state.data.trade_licence_file_name}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.tradeFileErrText}
                error={this.state.tradeFileError}
              />
              <label for="file-upload3" class="custom-file-upload" style={{ border: '1px solid #ccc', display: 'inline-block', padding: '6px 12px', cursor: 'pointer', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
                Browse
              </label>
              <input id="file-upload3" type="file" onClick={(event) => event.target.value = null} onChange={this.tradeFileHandler.bind(this)} style={{ display: "none" }} accept={formats} />
            </div><br/>
            <TextField
              label="*Beneficiary Name"
              placeholder="Enter Beneficiary Name"
              value={this.state.data.beneficiary_name}
              onChange={this.handleChange('beneficiary_name')}
              onClick={this.handleClick('beneficiary_name')}
              style={{ width: '250px', marginRight: '270px' }}
              helperText={this.state.beneficiary_nameErrText}
              error={this.state.beneficiary_nameErr}

            /><br />
            <div style={{ display: 'flex' }}><TextField
              label="*Bank Account Number"
              placeholder="Enter Account Number"
              value={this.state.data.bank_acc_number}
              onChange={this.handleChange('bank_acc_number')}
              onClick={this.handleClick('bank_acc_number')}
              onCut={(event) => { event.preventDefault() }}
              onCopy={(event) => { event.preventDefault() }}
              onPaste={(event) => { event.preventDefault() }}
              margin='normal'
              style={{ width: '250px' }}
              helperText={this.state.bank_acc_numberErrText}
              error={this.state.bank_acc_numberErr}

            /><br />
              <TextField
                label=" *Confirm Bank Account Number"
                placeholder="Enter Account Number"
                type='password'
                value={this.state.data.confirm_bank_acc_number}
                onChange={this.handleChange('confirm_bank_acc_number')}
                onClick={this.handleClick('confirm_bank_acc_number')}
                onCut={(event) => { event.preventDefault() }}
                onCopy={(event) => { event.preventDefault() }}
                onPaste={(event) => { event.preventDefault() }}
                margin='normal'
                style={{ width: '250px', marginLeft: '12px' }}

              /><br /></div>
            <TextField
              label="*IFSC Code"
              placeholder="Enter IFSC Code"
              value={this.state.data.ifsc_code}
              onChange={this.handleChange('ifsc_code')}
              onClick={this.handleClick('ifsc_code')}
              style={{ width: '250px', marginRight: '8px' }}
              helperText={this.state.ifsc_codeErrText}
              error={this.state.ifsc_codeErr}
            />
            <TextField
              label="*Bank Name"
              placeholder="Enter Bank Name"
              value={this.state.data.bank_name}
              onChange={this.handleChange('bank_name')}
              onClick={this.handleClick('bank_name')}
              margin='normal'
              style={{ width: '250px', marginLeft: '12px' }}
              helperText={this.state.bank_nameErrText}
              error={this.state.bank_nameErr}

            /><br />
            <div style={{ display: "flex" }}>
              <TextField
                label="*Cancel Cheque Copy"
                value={this.state.data.cancel_cheque_upload_file_name}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.cancelChequeErrorText}
                error={this.state.cancelChequeError}
              />
              <label for="file-upload1" class="custom-file-upload" style={{ border: '1px solid #ccc', display: 'inline-block', padding: '6px 12px', cursor: 'pointer', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
                Browse
              </label>
              <input id="file-upload1" type="file" onClick={(event) => event.target.value = null} onChange={this.chequeFileHandler.bind(this)} style={{ display: "none" }} accept={formats} />
            </div>
          </div>
        }
        <div style={{ display: 'flex' }}>
          <FormControl style={{ marginRight: '278px' }} margin='normal'>
            <InputLabel htmlFor="tds-liability">*TDS Liability</InputLabel>
            <Select
              value={'yes'}
              helperText={this.state.tdsLiabilityErrorText}
              error={this.state.tdsLiabilityError}
              onChange={this.handleChange('tds_liability')}
              onClick={this.handleClick('tds_liability')}
              inputProps={{
                name: 'TDS Liability',
                id: 'tds-liability',
              }}
              style={{ width: '250px', textAlign: 'left' }}
              disabled={true}  // disabling the dropdown and setting tds_liability always yes because Pancard is now mandatory.
            >
              {
                this.state.tds_liabilities.map(tds_liability => {
                  return <MenuItem value={tds_liability.toLowerCase()}>{tds_liability}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          {this.state.data.tds_liability === 'others' &&
            <TextField
              label="Please specify"
              placeholder="Enter Reason"
              value={this.state.data.tds_liability_remarks}
              onChange={this.handleChange('tds_liability_remarks')}
              onClick={this.handleClick('tds_liability_remarks')}
              style={{ width: '250px', marginLeft: '12px' }}
            />}</div>
        {this.state.data.tds_liability === 'yes' &&
          <div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
              <TextField
                label="*Pancard Number"
                placeholder="Enter Pancard Number"
                value={this.state.data.pancard_number}
                onChange={this.handleChange('pancard_number')}
                onClick={this.handleClick('pancard_number')}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.pancard_numberErrText}
                error={this.state.pancard_numberErr}
              />
                <FormControl margin='normal'>
                  <div style={{ marginLeft:'5rem' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.data.pancard_status == "0"}
                          onChange={this.handleChange('pancard_status')}
                          name="Pancard Status"
                          color="primary"
                          value='0'
                        />
                      }
                      label="*Inopertive"
                    />
                  </div>
                </FormControl>
                <span style={{ display: "flex", alignItems: "center", fontSize: "15px" }}>{this.state.data.pancard_status == "0" ? "(Pan status set to Inoperative)" : "(Pan status set to operative)"}</span>
            </div>
            <br />
            <div style={{ display: "flex" }}>
              <TextField
                label="*Upload Pancard Copy"
                value={this.state.data.pancard_file_name}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.pancardFileErrorText}
              error={this.state.pancardFileError}
              //   errorText={this.state.mouFileNameError}

              />
              <label for="file-upload2" class="custom-file-upload" style={{ border: '1px solid #ccc', display: 'inline-block', padding: '6px 12px', cursor: 'pointer', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
                Browse
</label>
              <input id="file-upload2" type="file" onClick={(event) => event.target.value = null} onChange={this.pancardFileHandler.bind(this)} style={{ display: "none" }} accept={formats} />
            </div>
            <br />
            <TextField
              label="Aadhaar Number"
              placeholder="Enter Aadhaar Number"
              value={(this.state.data.aadhar_number === "null" || this.state.data.aadhar_number === "undefined") ? "" : this.state.data.aadhar_number}
              onChange={this.handleChange('aadhar_number')}
              onClick={this.handleClick('aadhar_number')}
              margin='normal'
              style={{ width: '250px', marginRight: '278px' }}
              helperText={this.state.aadharNumberErrorText}
              error={this.state.aadharNumberError}
            /><br />
            <div style={{ display: "flex" }}>
              <TextField
                label="Upload Aadhaar Copy"
                value={this.state.data.aadhar_file_name}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.aadharFileErrorText}
                error={this.state.aadharFileError}
              //   errorText={this.state.mouFileNameError}

              />
              <label for="file-upload6" class="custom-file-upload" style={{ border: '1px solid #ccc', display: 'inline-block', padding: '6px 12px', cursor: 'pointer', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
                Browse
</label>
              <input id="file-upload6" type="file" onClick={(event) => event.target.value = null} onChange={this.aadharFileHandler.bind(this)} style={{ display: "none" }} accept={formats} />
            </div>
          </div>
        }
        <TextField
          label="Company Category"
          placeholder="Enter Company Category"
          value={this.state.data.company_category}
          onChange={this.handleChange('company_category')}
          onClick={this.handleClick('company_category')}
          margin='normal'
          style={{ width: '250px', marginRight: '278px' }}
        /><br />
        <TextField
          label="Contractual Terms"
          placeholder="Enter Contractual Terms"
          value={this.state.data.contractual_terms}
          onChange={this.handleChange('contractual_terms')}
          onClick={this.handleClick('company_category')}
          margin='normal'
          multiline
          style={{ width: '520px' }} /><br />
        <div>
          <FormControl style={{ marginRight: '278px' }} margin='normal'>
            <InputLabel htmlFor="vendor-agreement">*Vendor Agreement</InputLabel>
            <Select
              value={this.state.data && this.state.data.vendor_agreement ? String(this.state.data.vendor_agreement == 'null' ? '' : this.state.data.vendor_agreement) : ''}
              helperText={this.state.vendor_agreementErrorText}
              error={this.state.vendor_agreementError}
              onChange={this.handleChange('vendor_agreement')}
              onClick={this.handleClick('vendor_agreement')}
              inputProps={{
                name: 'Vendor Agreement',
                id: 'vendor-agreement',
              }}
              style={{ width: '250px', textAlign: 'left' }}
            >
              <MenuItem value="1">Yes</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </Select>
          </FormControl>
        </div><br />
        {this.state.data.vendor_agreement === '1' ? (
          <Fragment>
            <DatePicker
              label="Expiry Date"
              placeholder="Select Agreement Expiry Date"
              value={this.state.data.agreement_expiry_date}
              disabled={!this.state.data.vendor_agreement || this.state.data.vendor_agreement === '0'}
              onChange={this.handleChange('agreement_expiry_date')}
              onClick={this.handleClick('agreement_expiry_date')}
              minDate={new Date()}
              errorText={this.state.agreementExpiryDateErrorText}
              margin='normal'
              style={{ width: '520px' }} />
            <div>
              <div style={{display: "flex"}}>
                <TextField
                  label="Upload Agreement"
                  value={this.state.data.vendor_agreement_file_name}
                  defaultValue={this.state.data.vendor_agreement_file_name}
                  margin='normal'
                  style={{width: '250px'}}
                  disabled={true}
                  helperText={this.state.vendorAgreementErrorText}
                  error={this.state.vendorAgreementError}
                />
                <label htmlFor="file-upload4" className="custom-file-upload" style={{
                  border: '1px solid #ccc',
                  display: 'inline-block',
                  padding: '6px 12px',
                  cursor: 'pointer',
                  height: '13px',
                  marginTop: '37px',
                  marginLeft: '18px'
                }}>
                  Browse
                </label>
                <input 
                  id="file-upload4" 
                  type="file" 
                  onClick={(event) => event.target.value = null}
                  onChange={this.vendorAgreementFileHandler.bind(this)} 
                  style={{ display: "none" }} 
                  accept={formats}
                  disabled={!this.state.data.vendor_agreement || this.state.data.vendor_agreement === '0'}
                />
              </div>
            </div>
          </Fragment>
        ) : null}
        <div>
          <FormControl style={{ marginRight: '278px' }} margin='normal'>
            <InputLabel htmlFor="msme-vendor">*MSME Vendor</InputLabel>
            <Select
              value={String(this.state.data.msme_vendor)}
              helperText={this.state.msme_vendorErrText}
              error={this.state.msme_vendorErr}
              onChange={this.handleChange('msme_vendor')}
              onClick={this.handleClick('msme_vendor')}
              inputProps={{
                name: 'MSME Vendor',
                id: 'msme-vendor',
              }}
              style={{ width: '250px', textAlign: 'left' }}
            >
              <MenuItem value="1">Yes</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </Select>
          </FormControl>
        </div>
        {this.state.data.msme_vendor == '1' ? (
          <div>
            <div style={{display: "flex"}}>
              <TextField
                label="Upload MSME Certificate"
                value={this.state.data.msme_certificate_file_name}
                margin='normal'
                style={{width: '250px'}}
                disabled={true}
                helperText={this.state.msmeCertificateErrorText}
                error={this.state.msmeCertificateError}
              />
              <label htmlFor="file-upload5" className="custom-file-upload" style={{
                border: '1px solid #ccc',
                display: 'inline-block',
                padding: '6px 12px',
                cursor: 'pointer',
                height: '13px',
                marginTop: '37px',
                marginLeft: '18px'
              }}>
                Browse
              </label>
              <input id="file-upload5" type="file" onClick={(event) => event.target.value = null}
                    onChange={this.msmeCertificateFileHandler.bind(this)} style={{display: "none"}} accept={formats}/>
            </div>
          </div>
        ): null}
        <TextField
          label="Vendor Defaultor Amount"
          placeholder="Enter defaulted amount"
          value={String(this.state.data.defaultor_amount)}
          type='number'
          onChange={this.handleChange('defaultor_amount')}
          onClick={this.handleClick('defaultor_amount')}
          margin='normal'
          style={{ width: '250px', marginRight: '278px' }}
        /><br />
        <div>
          <FormControl style={{ marginRight: '278px' }} margin='normal'>
            <InputLabel htmlFor="vendor-agreement">*Vendor LDC Agreement</InputLabel>
            <Select
              value={String((this.state.data.vendor_ldc_agreement == '1'  || this.state.data.vendor_ldc_agreement == '0') ? this.state.data.vendor_ldc_agreement : '')}
              error={this.state.vendor_ldc_agreementErr}
              onChange={this.handleChange('vendor_ldc_agreement')}
              onClick={this.handleClick('vendor_ldc_agreement')}
              inputProps={{
                name: 'Vendor LDC Agreement',
                id: 'vendor-ldc-agreement',
              }}
              style={{ width: '250px', textAlign: 'left' }}
            >
              <MenuItem value="1">Yes</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </Select>
            {this.state.vendor_ldc_agreementErr && <FormHelperText
              style={{
                color: 'red'
              }}
            >
              {this.state.vendor_ldc_agreementErrText}
            </FormHelperText>}
          </FormControl>
        </div><br />
        {this.state.data.vendor_ldc_agreement == '1' ? (
          <Fragment>
            <div 
              style={{ 
                width: '600px', 
                display: 'flex' , 
                flexDirection: 'row',
                gap: '0.5rem',
                alignItems: 'center'
              }}
            >
              <DatePicker
                label="LDC Start Date"
                placeholder="*Select LDC Agreement Start Date"
                value={this.state.data.ldc_agreement_start_date}
                disabled={!this.state.data.vendor_ldc_agreement || this.state.data.vendor_ldc_agreement === '0'}
                onChange={this.handleChange('ldc_agreement_start_date')}
                onClick={this.handleClick('ldc_agreement_start_date')}
                errorText={this.state.ldc_agreement_start_dateErrText}
                error={this.state.ldc_agreement_start_dateErr}
                margin='normal'
                style={{ width: '250px' }} 
              />
              <KeyboardArrowRight />
              <DatePicker
                label="LDC End Date"
                placeholder="*Select LDC Agreement End Date"
                value={this.state.data.ldc_agreement_end_date}
                disabled={!this.state.data.ldc_agreement_start_date}
                onChange={this.handleChange('ldc_agreement_end_date')}
                onClick={this.handleClick('ldc_agreement_end_date')}
                minDate={this.state.data.ldc_agreement_start_date}
                errorText={this.state.ldc_agreement_end_dateErrText}
                error={this.state.ldc_agreement_end_dateErr}
                margin='normal'
                style={{ width: '250px' }} 
              />
            </div>
            {this.state.data && this.state.data.ldc_tds_rate_data.map((item, index) => (
              <div
                style={{ 
                  width: '50rem', 
                  display: 'flex' , 
                  flexDirection: 'row',
                  gap: '0.5rem',
                  alignItems: 'center'
                }}
              >
                <FormControl style={{ width: '100%' }} margin='normal'>
                  <InputLabel htmlFor="ldc-section-name">*LDC TDS Section Type</InputLabel>
                  <Select
                    value={item.tds_section_name_id}
                    onChange={(e) => this.handleChange('tds_section_name_id')(e, index)}
                    onClick={(e) => this.handleClick('tds_section_name_id')(e, index)}
                    style={{ width: '100%' }}
                    error={this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].tds_section_name_idErr}
                    inputProps={{
                      name: 'Select LDC TDS Section Typ',
                      id: 'vendor-ldc-agreement',
                    }}
                  >
                    {
                      this.state.ldcTdsSectionTypes.map(ldcTdsSectionType => (
                        <MenuItem value={ldcTdsSectionType.id}>
                          {ldcTdsSectionType.section_name}
                        </MenuItem>
                      ))
                    }
                  </Select>
                  {this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].tds_section_name_idErr && (
                    <FormHelperText style={{ color: 'red' }}>
                      {this.state.ldc_tds_rate_ErrData[index].tds_section_name_idErrText}
                    </FormHelperText>
                  )}
                </FormControl><br />
                <TextField
                  label="*LDC Amount Limit"
                  placeholder="Enter ldc amount limit"
                  value={String(item.ldc_amount_limit)}
                  type='number'
                  onChange={(e) => this.handleChange('ldc_amount_limit')(e, index)}
                  onClick={(e) => this.handleClick('ldc_amount_limit')(e, index)}
                  helperText={this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].ldc_amount_limitErrText}
                  error={this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].ldc_amount_limitErr}
                  margin='normal'
                  style={{ width: '100%' }}
                /><br />
                <TextField
                  label="*LDC Rate"
                  placeholder="*Enter ldc rate"
                  value={String(item.ldc_rate)}
                  type='number'
                  onChange={(e) => this.handleChange('ldc_rate')(e, index)}
                  onClick={(e) => this.handleClick('ldc_rate')(e, index)}
                  helperText={this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].ldc_rateErrText}
                  error={this.state.ldc_tds_rate_ErrData[index] && this.state.ldc_tds_rate_ErrData[index].ldc_rateErr}
                  margin='normal'
                  style={{ width: '100%' }}
                /><br />
                {((this.state.data.ldc_tds_rate_data.length - 1) == index) ? (
                  <AddCircle 
                    style={{ 
                      color: '#00AEEF', 
                      marginTop: '20px', 
                      cursor: 'pointer' 
                    }} 
                    onClick={this.addLdcTdsRate}
                  />
                ) : (
                  <DoNotDisturbOn 
                    style={{ 
                      color: 'red', 
                      marginTop: '20px', 
                      cursor: 'pointer' 
                    }}
                    onClick={() => this.removeLdcTdsRate(index)}
                  />
                )}
              </div>
            ))}
            <div>
              <div style={{display: "flex"}}>
                <TextField
                  label="*Upload LDC Agreement"
                  value={this.state.data.vendor_ldc_agreement_file_name}
                  defaultValue={this.state.data.vendor_ldc_agreement_file_name}
                  margin='normal'
                  style={{width: '250px'}}
                  disabled={true}
                  helperText={this.state.vendor_ldc_agreement_file_nameErrText}
                  error={this.state.vendor_ldc_agreement_file_nameErr}
                />
                <label htmlFor="file-upload7" className="custom-file-upload" style={{
                  border: '1px solid #ccc',
                  display: 'inline-block',
                  padding: '6px 12px',
                  cursor: 'pointer',
                  height: '13px',
                  marginTop: '37px',
                  marginLeft: '18px'
                }}>
                  Browse
                </label>
                <input 
                  id="file-upload7" 
                  type="file" 
                  onClick={(event) => event.target.value = null}
                  onChange={this.vendorLdcAgreementFileHandler.bind(this)} 
                  style={{ display: "none" }} 
                  accept={formats}
                  disabled={!this.state.data.vendor_ldc_agreement || this.state.data.vendor_ldc_agreement == '0'}
                />
              </div>
            </div>
          </Fragment>
        ) : null}
        <TextField
          label="Central finance comment"
          value={this.state.data.central_finance_remarks ? this.state.data.central_finance_remarks : ''}
          disabled
          margin='normal'
          style={{ width: '520px' }} /><br />
        <TextField
          label="Vendor Approver L2 comment"
          value={this.state.data.vendor_approver_l2_remarks ? this.state.data.vendor_approver_l2_remarks : ''}
          disabled
          margin='normal'
          style={{ width: '520px' }} /><br />
        <TextField
          label="City finance comment"
          placeholder="Enter Comment"
          value={this.state.data.city_finance_remarks}
          margin='normal'
          style={{ width: '520px' }}
          onChange={this.handleChange('city_finance_remarks')}
        /><br />
        <div className="zaps-form-actions">
          <RaisedButton
            label="Clear"
            primary={true}
            onClick={this.handleClear.bind(this)}
            buttonStyle={{ backgroundColor: 'red' }}
          />
          <RaisedButton
            label="Back"
            primary={true}
            onClick={this.props.handleBack.bind(this, this.state.data)}
            style={{ marginLeft: '20px' }}
          />

          <RaisedButton style={{ marginLeft: '20px' }} label={`Next`} primary={true} onClick={this.handleNext.bind(this)} />
        </div>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
        <Dialog
          open={this.state.vendorExistsDialogBox}
          onClose={this.handleCloseVendorExistsDialogBox.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.vendorExistsDialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseVendorExistsDialogBox.bind(this)} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showBankAplhaNumDialog}
          onClose={this.handleBankAplhaNumDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogTitle id="alert-dialog-title">{"Alphanumeric Entry For A/C"}</DialogTitle>
            <DialogContentText id="alert-dialog-description">
            The A/C Number added is alpha-numeric. Are you sure the number is correct?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleBankAplhaNumDialogNo.bind(this)} color="primary">
              No
            </Button>
            <Button onClick={this.handleBankAplhaNumDialogYes.bind(this)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

}
export default VendorFinancialDetails



// WEBPACK FOOTER //
// ./src/components/VendorFinancialDetails.js